import React from 'react';
import {
    Table,
    TableBody,
    TableRow,
} from '@mui/material';
import { splitWords } from 'utils/helpers';


const patientTabInfo = ({ patientInfo }) => {
    return (
        <div className="row content-info">
            <div className="col-lg-12">
                <h4 className="profile-view-subtitle d-block purpleText">General Information</h4>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <Table className="table-view-details">
                    <TableBody>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">ID</td>
                            <td>{patientInfo.id}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Full Name</td>
                            <td className="table-view-data">{patientInfo.fullName}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Preferred Name</td>
                            <td>{patientInfo.preferredName}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Gender</td>
                            <td className="table-view-data">{patientInfo.gender}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Date of Birth</td>
                            <td>{patientInfo.dateOfBirth ? patientInfo.dateOfBirth : ""}</td>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <Table className="table-view-details">
                    <TableBody>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Care Giver</td>
                            <td>{patientInfo.careGiver}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Status</td>
                            <td className={patientInfo.status !== "Active" ? "statusIconRed m-0" : "statusIconGreen m-0"}>{patientInfo.status}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Identification Type</td>
                            <td>{splitWords(patientInfo.identificationType || "")}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Identification Number</td>
                            <td>{patientInfo.identificationNumber}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Member Since</td>
                            <td>{patientInfo.memberSince}</td>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>

            {/* Contact Information */}

            <div className="col-lg-12 clear-both pt-3">
                <h4 className="profile-view-subtitle d-block pt-3 purpleText">Contact Information</h4>
            </div>

            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <Table className="table-view-details">
                    <TableBody>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Address</td>
                            <td>{patientInfo.address}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">City</td>
                            <td>{patientInfo.city}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Province</td>
                            <td>{patientInfo.state}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Postal Code</td>
                            <td className="table-view-data text-uppercase">{patientInfo.postalCode}</td>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <Table className="table-view-details">
                    <TableBody>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Country</td>
                            <td>{patientInfo.country}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Phone</td>
                            <td>{patientInfo.phone}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Email</td>
                            <td className="view-email">{patientInfo.email}</td>
                        </TableRow>
                        <TableRow className="table-view-info">
                            <td className="table-view-title">Preferred Contact</td>
                            <td>{(patientInfo.contactMethodsTypes || []).map(c => `(${c}) `)}</td>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        </div>
    );
};

export default patientTabInfo;